import {InfoInterface} from "./Info.interface";
import {FieldSchema} from "@/schema/Field.schema";

export const InfoSchema: InfoInterface = {
    fields: {
        afishaImage: FieldSchema,
        title: FieldSchema,
        type: FieldSchema,
        status: FieldSchema,
        statusCode: FieldSchema,
        category: FieldSchema,
        age: FieldSchema,
        isHidden: FieldSchema,
        dates: FieldSchema,
        datesTimezone: FieldSchema,
        dateStart: FieldSchema,
        prices: FieldSchema,
        eventCopyId: FieldSchema,
        address: FieldSchema,
        access: FieldSchema,
        releasePeriodLabel: FieldSchema,
        releasePeriod: FieldSchema,
        isWidget: FieldSchema
    },
    eventSlug: null,
    eventAfishaId: null,
    landingUrl: null,
    previewUrl: null,
    checkUrl: null,
    cabinetUrl: null,
    overallSum: null,
    expectedProfit: null,
    overallTickets: null,
    tags: null,
    utc: null,
    timezone: null,
    newEventTitle: '',
    isTitleEdit: false,
    isShowMore: false,
    commissionRate: null,
    commissionRates: null,
}
